<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M36.61 11.39a15 15 0 00-22.22 20.1L7.58 38.3a1.49 1.49 0 000 2.12 1.5 1.5 0 002.12 0l6.81-6.81a15 15 0 0020.1-22.22zm-2.12 19.1A12 12 0 1138 22a12 12 0 01-3.51 8.49z"/></svg>